import api from '../services/api';

const SHIPPING_QUOTES_URL = '/shippingQuotes';
const SHIPPING_QUOTES_DEFAULTS_URL = '/shippingQuotes/defaults';

const shippingQuoteService = {
    getQuotes,
    getDefaults,
};

export default shippingQuoteService;

/**
 * Fetch the selectable checkout shipping rates for a destination. Unlike the cart-side estimate on
 * `/projects/v2/{id}/shipping/services`, this returns `isVendorService`, which the project PATCH needs
 * in order to persist the chosen service.
 *
 * Send the whole destination, not just its country, state and zip. `ShippingQuoteProvider#buildClassifiableShipToAddress`
 * only classifies the requested address as residential or commercial when `addressLine1` *and* `city`
 * are both non-blank - a bare zip cannot be classified, so it does not try. Omit either and the
 * provider falls back to `validateAddressAndSetResidentialFlag(cart)`, which classifies whatever
 * address is currently stored on the project instead of the one being quoted, and the quote comes
 * back with the wrong residential service on it (FedEx Ground where Home Delivery was due, and the
 * reverse) rather than with an error.
 */

function getQuotes (destination) {
    const requestConfig = {
        url: SHIPPING_QUOTES_URL,
        method: 'POST',
        data: buildQuotePayload(destination),
    };

    return api(requestConfig);
}

/**
 * Build the ShippingQuoteRequestDTO payload. Separate from the request so the field renaming - the
 * part that fails silently when it is wrong, because the server drops unrecognized keys and quotes
 * anyway - can be tested without a network layer.
 *
 * @param {Object} destination - The destination to quote.
 * @returns {Object} The request payload.
 */

export function buildQuotePayload ({ projectId, countryId, stateId, postalCode, address, address2, city, totalOunces = 0 }) {
    return {
        projectId,
        countryId,
        stateId,
        zip: postalCode,
        addressLine1: address,
        addressLine2: address2,
        city,
        totalOunces,
    };
}

function getDefaults () {
    const requestConfig = {
        url: SHIPPING_QUOTES_DEFAULTS_URL,
        method: 'GET',
    };

    return api(requestConfig);
}
